import { Dayjs } from "dayjs"

/**
 * Mirrors the `warrants_job_status` Postgres enum exposed by Hasura on the
 * be-financials source.
 */
export enum WarrantsJobStatus {
  STARTED = "started",
  COMPLETED = "completed",
  FAILED = "failed",
}

export interface IWarrantsJob {
  id: number
  status: WarrantsJobStatus
  message: string | null
  startedAt: Dayjs
  endedAt: Dayjs | null
  createdAt: Dayjs
  updatedAt: Dayjs
  deletedAt: Dayjs | null

  /** `deleted_at` is set. */
  readonly isDeleted: boolean
  /** The status enum value rendered for display, e.g. 'Completed'. */
  readonly statusDisplay: string
}
